enum ConnectionFields {
	HOST = "host",
	PATH = "path",
	ENABLED = "enabled",
	IP = "ip",
	PORT = "port",
	SSL = "ssl",
	SSL_PROTOCOL = "ssl_protocol",
	PROTOCOL = "protocol",
	DELETE = "delete",
	CERTIFICATE = "certificate",
	ADD = "add",
	THREADS = "ssl_threads"
}

export default ConnectionFields;